export default __webpack_public_path__ + "static/media/Asset 3.e7dc01f5.svg";